export default "__VITE_ASSET__9765d2f1__"